



























import Vue from 'vue';
import Component from 'vue-class-component';
import { user } from '@/modules/shared/shared/store/namespaces';
import TicketCreateModal from '@/modules/tickets/dashboard/components/TicketCreateModal.vue';
import { Actions, Resources } from '@/modules/shared/shared/domain/constants/constants';
import BaseModal from '@/modules/shared/layouts/components/BaseModal.vue';

@Component({
    components: { BaseModal, TicketCreateModal },
})
export default class TicketsDashboardHeader extends Vue {
    dialog: boolean = false;
    createAction: string = Actions.CREATE.name;
    pdtResourceName: string = Resources.PDT.name;
    ticketsResourceName: string = Resources.TICKETS.name;
    remoteHandsResourceName: string = Resources.REMOTE_HANDS.name;

    $refs!: {
        modal: any;
    };

    closeDialog() {
        this.$refs.modal.closeModal();
    }
}
